const toCamel = (str: string): string =>
  str.replace(/([-_][a-z])/gi, ($1) => $1.toUpperCase().replace('-', '').replace('_', ''));

export const toCamelCase = <T>(obj: unknown): T => {
  if (obj === null || typeof obj !== 'object') {
    return obj as T;
  }

  if (Array.isArray(obj)) {
    return obj.map((item) => toCamelCase(item)) as unknown as T;
  }

  const result: Record<string, unknown> = {};
  for (const key of Object.keys(obj as Record<string, unknown>)) {
    result[toCamel(key)] = toCamelCase((obj as Record<string, unknown>)[key]);
  }

  return result as T;
};
